<template>
  <div>
    <vxe-grid
      ref="editTable"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :height="640"
      row-key
      row-id="amzReplenishmentDetailCode"
      cell-class-name="align-top"
      :row-class-name="rowClassName"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="{ strict: true }"
      @cell-click="cellClick"
    >
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:60px;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:60px;" />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="d-flex">
          <div style="flex:1">
            <span>{{ row.goodsName }}</span>
            <br />
            <span>{{ row.goodsNameEn }}</span>
            <br />
            <span>分类: </span>
            <span style="color: #303133">{{ row.masterCategoryName }}</span>
            <br />
            <span>SKU: </span
            ><span style="color: #303133">{{ row.amzSkuNo }}</span>
            <br />
            <span>Store SKU: </span
            ><span style="color: #409EFF">{{ row.amzSkuStoreNo }}</span>
            <br />
            <span>ASIN: </span>
            <span style="color: #409EFF">{{ row.asinCode }}</span>
            <br />
            <span>FNSKU: </span>
            <span style="color: #409EFF">{{ row.fnskuCode }}</span>
          </div>
          <div>
            <div class="alert-level-tag">
              <span :style="{ backgroundColor: row.alertLevelColor }" />
              <span :style="{ backgroundColor: row.alertLevelColor }" />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: { refresh: { query: () => this.$emit('reload') } },
      tableColumns: tableColumns(this),
      rowCurrentKey: '',
    }
  },
  methods: {
    /**
     * 设置表格选中效果
     */
    rowClassName({ row }) {
      const { amzReplenishmentDetailCode } = row
      if (this.rowCurrentKey === amzReplenishmentDetailCode) {
        return 'row--current'
      }
    },
    /**
     * 由于表格自带选中事件，拦截不了表格选中效果
     */
    cellClick(e) {
      const { row } = e
      const { amzReplenishmentDetailCode } = row
      if (this.rowCurrentKey === amzReplenishmentDetailCode) return
      this.$emit('current-change', e)
    },
    setCurrentRow(rowid) {
      this.rowCurrentKey = rowid
    },
    clearCurrentRow() {
      this.rowCurrentKey = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.alert-level-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
  span {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    opacity: 0.75;
  }
  span:first-child {
    position: absolute;
    animation: ping 1.5s cubic-bezier(0, 0, 0.1, 0.6) infinite;
  }
  span:last-child {
    position: relative;
  }

  @keyframes ping {
    75%,
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
}
</style>
